import React from 'react'
import {
  Table,
  Button,
  ButtonToolbar,
  ButtonGroup} from 'reactstrap';
import { Link } from 'react-static'
import { saveAs } from 'file-saver'
import JSZip from 'jszip'

import Order from './OrderItem'
import { toDate, toDateHuman } from '../share/date_helper'
import { orderAmount} from '../share/order_helper'
import TimeRangeFilter from './TimeRangeFilter'
import {createInvoice} from '../share/pdf_invoice_generator'
import Spinner from './Spinner'

export default class Orders extends React.Component {
  constructor(props) {
    super(props)
    const startDate = new Date()
    startDate.setDate(1)
    startDate.setMonth(startDate.getMonth()-1)
    const endDate = new Date()

    this.state = {startDate, endDate, creatingPDF: false}
  }

  exportAsJSON = () => {
    const timeRange = `${toDateHuman(this.state.startDate)}_${toDateHuman(this.state.endDate)}`
    const filename = `Auftraege_${timeRange}.json`
    const data = new Blob([JSON.stringify(this.filterItems())], {type: "text/plain;charset=utf-8"});
    saveAs(data, filename);
  }

  exportAsPDF = () => {
    this.setState({creatingPDF: true}, () => {
      const timeRange = `${toDateHuman(this.state.startDate)}_${toDateHuman(this.state.endDate)}`
      const orders = this.filterItems()

      // create and collect pdf creator promises  
      const pdfCreators = orders.map(order => new Promise((resolve) => 
        createInvoice(order,this.props.companyData).getBase64(data => 
          resolve({order,data})
        )
      ))  

      // resolve all pdf creators
      Promise.all(pdfCreators)
      .then(data => {
        // create zip object  
        const zip = new JSZip()
        // add folder to zip
        const billsZip = zip.folder(`Rechnungen ${timeRange}`)
        // add pdf files to the folder
        data.forEach(pdf => {
          const orderDate = toDateHuman(pdf.order.date)  
          billsZip.file(`${orderDate}_${pdf.order.number}.pdf`, pdf.data, {base64: true})
        })
        // create and return zip blob
        return zip.generateAsync({type:"blob"})
      }).then((content) => {
        this.setState({creatingPDF: false})
        // download zip
        saveAs(content, `Rechnungen ${timeRange}.zip`)
      })
    })
  }

  filterItems = () => {
    const orders = this.props.orders
    return orders.filter(order => {
      const date = new Date(toDate(order.date))
      const startDate = new Date(this.state.startDate)
      const endDate = new Date(this.state.endDate)
      date.setHours(0,0,0,0)
      startDate.setHours(0,0,0,0);
      endDate.setHours(0,0,0,0);
      
      return date >= startDate && date <= endDate
    })
  }

  ammount = (orders) => {
    const sum = {totalNett: 0, totalGross: 0, totalCancelled: 0, totalShippingCosts: 0}
    orders.forEach(order => {
      if(order.cancelled) sum.totalCancelled += 1
      else {
        const currentAmmount = orderAmount(order)
        sum.totalNett += currentAmmount.totalNett
        sum.totalGross += currentAmmount.totalGross
        sum.totalShippingCosts += currentAmmount.shippingCosts
      }
    })
    sum.totalTax = sum.totalGross-sum.totalNett
    sum.totalTaxHuman = Number(sum.totalTax.toFixed(2)).toLocaleString('de-DE')
    sum.totalNettHuman = Number(sum.totalNett.toFixed(2)).toLocaleString('de-DE')
    sum.totalGrossHuman = Number(sum.totalGross.toFixed(2)).toLocaleString('de-DE')
    sum.totalShippingCosts = Number(sum.totalShippingCosts.toFixed(2)).toLocaleString('de-DE')

    return sum
  }

  render() {
    const orders = this.filterItems()
    const ammount = this.ammount(orders)

    return(
      <React.Fragment>

        <div className="card-box" >
          <ButtonToolbar className="justify-content-between">

            <TimeRangeFilter 
              startDate={this.state.startDate} 
              endDate={this.state.endDate}
              onChange={(startDate,endDate) => this.setState({startDate,endDate})}/>  

            <ButtonGroup>
              <Button 
                className="btn btn-purple btn-sm" onClick={this.exportAsPDF} 
                disabled={this.state.creatingPDF || !this.props.companyData}>
                {this.state.creatingPDF && <Spinner/>}
                PDF <i className="fas fa-file-invoice-dollar"/>
              </Button>
              <Button className="btn btn-purple btn-sm" onClick={this.exportAsJSON}>
                JSON <i className="fas fa-file-export"/>
              </Button>
              <Link to='/orders/new' className="btn btn-success btn-sm waves-effect waves-light">
                Neuer Auftrag <i className="fas fa-plus-square"/>
              </Link>
            </ButtonGroup>
          </ButtonToolbar>
        </div>

        <div className="row">
          <div className="col-lg-3 col-md-6">
              <div className="widget-simple text-center card-box">
                  <h3 className="text-success counter font-bold mt-0">
                    <span className="counter">{ammount.totalNettHuman}</span>€
                  </h3>
                  <p className="text-muted mb-0">Netto</p>
              </div>
          </div>

          <div className="col-lg-3 col-md-6">
              <div className="widget-simple text-center card-box">
                  <h3 className="text-primary counter font-bold mt-0">
                    <span className="counter">{ammount.totalGrossHuman}</span>€
                  </h3>
                  <p className="text-muted mb-0">Brutto</p>
              </div>
          </div>

          <div className="col-lg-3 col-md-6">
              <div className="widget-simple text-center card-box">
                  <h3 className="text-pink font-bold mt-0">
                    <span className="counter">{ammount.totalTaxHuman}</span>€
                  </h3>
                  <p className="text-muted mb-0">Umsatzsteuer</p>
              </div>
          </div>

          <div className="col-lg-3 col-md-6">
              <div className="widget-simple text-center card-box">
                  <h3 className="text-purple counter font-bold mt-0">
                    {ammount.totalShippingCosts}€
                  </h3>
                  <p className="text-muted mb-0">Versandkosten</p>
              </div>
          </div>
      </div>

      <div className=" card-box table-responsive" >
        <Table striped responsive className="m-t-20">
          <thead>
            <tr>
              <th className="snug"># {orders.length}</th>
              <th align="left">Bestelldatum</th>
              <th align="left">Nummer</th>
              <th align="left">Kunde</th>
              <th align="left">Betrag</th>
              <th align="left">Bestellt bei</th>
              <th align="left">Storniert ({ammount.totalCancelled})</th>
              <th align="left"/>
            </tr>
          </thead>
          <tbody>
            {!!orders && orders.map(order =>
              <Order  key={order.id} order={order}/>
            )}
          </tbody>
        </Table>

      </div>
    </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/OrderList.js